<template  >
<v-layout column fill-height="">

    <not-toolbar-sub :not="not"/>  
    <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 

    <!-- //page --> 
    <v-layout column fill-height v-else class="mx-10 mb-10 ">
        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!page_show"/> 
        <div v-else>
            
            <!-- RESULTS INDICATOR -->
            <v-card class="mt-5 mb-5" shaped="" color="primary lighten-"  >
                <v-card-title class="white--text">
                    <v-layout row wrap class="px-3">
                        <div>SUBMITTED RESULTS INDICATOR</div>
                        <v-spacer></v-spacer>
                        <!-- <div><v-btn color="accent" rounded="" dark="" outlined="">{{resultsType}}</v-btn></div> -->
                    </v-layout> 
                </v-card-title>
                <v-card-text>
                    <div class="mb-2"
                        v-for="(result , index) in not.CALCULATE_RESULTS_INDICATOR(resultsType)" :key="index">
                        <v-card color="primary" hover flat="">
                            <v-layout justify-center="" align-cente="" class="pa-0 ma-0" @click="changeResultsType(result.name)">
                                <v-progress-linear  class="mr-5"
                                    :color="not.TEXT_EQ(result.name,submitResultsLevel)?'accent':'b2'"
                                    height="25"
                                    :value="result.value"
                                    reactive  striped="">
                                    <template v-slot="{ value }">
                                        <strong>{{result.name}}: {{ Math.ceil(value) }}%</strong>
                                    </template>  
                                </v-progress-linear>  
                                <div class="ma-0 pa-0" >
                                    <v-icon v-if="not.TEXT_EQ(result.name,submitResultsLevel)" size="27" color="accent">check_box</v-icon>
                                    <v-icon v-else size="27" color="b2">check_box_outline_blank</v-icon> 
                                </div>
                                
                            </v-layout>
                            
                        </v-card>
                    </div>
                </v-card-text>
            </v-card> 
 

            <!-- RESULTS TOOLBAR -->
            <v-toolbar color="primary" dark="" tile=""  >
                <v-toolbar-title>
                    MANAGE RESULTS
                </v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn @click="addResult()" color="white" 
                    outlined="" rounded="" icon="" class="mr-2">
                    <v-icon size="18" class="pr-1">mdi-plus-thick</v-icon>
                </v-btn> 
                <v-menu bottom left 
                    v-model="menuGroup"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                        <v-btn class="mr-2"
                            dark outlined="" 
                            rounded=""
                            icon
                            v-on="on" >
                            <v-icon>mdi-group</v-icon>
                        </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                GROUP RESULTS
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuGroup=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_results_group" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="groupResults(item,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuGroup = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>
                <v-menu bottom left 
                    v-model="menuFilter"
                    :close-on-content-click="false"
                    :nudge-width="250">
                    <template v-slot:activator="{ on }">
                    <v-btn
                        dark outlined="" rounded=""
                        icon
                        v-on="on"
                    >
                        <v-icon>mdi-tune</v-icon>
                    </v-btn>
                    </template>

                    <v-card>
                        <v-card-title primary-title>
                            <v-layout >
                                CUSTOMIZE RESULTS
                                <v-spacer></v-spacer>
                                <v-btn icon="" @click="menuFilter=false"><v-icon>close</v-icon></v-btn>
                            </v-layout>
                        </v-card-title>
                        <v-card-text>
                            <v-list subheader="" dense="">
                                <div v-for="(item, i) in xHeader_results_customise" :key="i">
                                    <v-subheader v-if="item.title">{{item.name}}</v-subheader>
                                    <v-list-item v-else  @click="not.TABLE_HEADER_SELECTOR(xHeader_results_customise,i)" >
                                        <v-list-item-icon><v-icon>{{item.show?"mdi-check-box-outline":"mdi-checkbox-blank-outline"}}</v-icon></v-list-item-icon>
                                        <v-list-item-title>{{item.name}}</v-list-item-title>
                                    </v-list-item> 
                                </div> 
                            </v-list> 
                            <v-layout >
                                <v-spacer></v-spacer>
                                <v-btn @click="menuFilter = false" color="primary">OK</v-btn>
                            </v-layout>
                        </v-card-text>
                        
                    </v-card> 
                </v-menu>
                <v-btn color="white" outlined="" rounded="" icon="" class="ml-2"><v-icon size="18" class="pr-1">mdi-download</v-icon></v-btn>

                <v-menu bottom left>
                    <template v-slot:activator="{ on }">
                    <v-btn
                        dark
                        icon
                        v-on="on"
                    >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                    </template>

                    <v-list>
                        <v-list-item  @click="menuGroup=true" >
                            <v-list-item-title>Group Results</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="menuFilter=true" >
                            <v-list-item-title>Customize Results</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="addResult()" >
                            <v-list-item-title>Add Results Manually</v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="addExcelResuts()" >
                            <v-list-item-title>Import Results from Excel </v-list-item-title>
                        </v-list-item>
                        <v-list-item  @click="downloadResults()" >
                            <v-list-item-title>Download Results</v-list-item-title>
                        </v-list-item> 
                        <v-list-item  @click="deleteAllResults()" >
                            <v-list-item-title>Delete ALL Results</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            
            <!-- RESULTS TABLE -->
            <v-card color="b1" v-if="accessResults('read')"> 
                <!-- //Show Results -->
                <not-page-spinner 
                    :notShow="true" 
                    :not="not"
                    v-if="!page_show_results"/> 

                <!-- //Wards table -->
                <div v-else-if="JOINED_results">
                    <!-- SHOW ALL -->
                    <div v-if="isGrouped('Show All')">
                        <not-table-results 
                            @onDeleteResult="deleteResult"
                            :not="not"
                            :notTitle="'ALL RESULTS'"
                            :notShow="true"
                            :notItems="JOINED_results"
                            :notHeaders="headerss('results_customise')"/> 
                    </div>
                    <div v-else class="pa-2">
                        <!-- TOOLBAR -->
                        <v-card-title class="primary lighten-3">
                            Grouped as {{isGrouped()}} 
                            <v-spacer></v-spacer>
                            <v-text-field
                                v-model="searchGroup"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                            ></v-text-field>
                        </v-card-title>

                        <!-- HEADER -->
                        <v-list-item class="primary lighten-3" >
                            <v-list-item-action>
                                <div v-if="isGrouped()==='Candidates'" class="mx-6"></div>
                                <div class="not-f2" v-else>NO.</div>
                            </v-list-item-action>
                            <v-list-item-content>
                                <div class="not-f2">{{isGrouped().toUpperCase()}} </div>
                            </v-list-item-content> 
                            <v-list-item-action><div class="not-f2">VOTES({{listGroupResults(isGrouped()).NUMBER}})</div></v-list-item-action>
                            <v-list-item-action/>   
                            <v-list-item-action/>
                        </v-list-item  >

                        <!-- LIST   -->
                        <v-list color="b1">
                            <div v-if="listGroupResults(isGrouped()).items.length>=1">
                                <div 
                                    v-for="(item, index) in listGroupResults(isGrouped()).items"
                                    :key="index"> 
                                    <v-divider></v-divider>
                                    <v-list-group>
                                        <template v-slot:activator>
                                            <v-list-item-action>
                                                <div v-if="isGrouped()==='Candidates'" >
                                                    <div v-if="item.image_link">
                                                        <v-list-item-avatar size="50" class="ma-0 pa-a">
                                                            <v-img :src="item.image_link" />  
                                                        </v-list-item-avatar>
                                                    </div>
                                                    <div v-else>
                                                        <v-list-item-avatar size="50" color="b2" class="ma-0 pa-a"> 
                                                        </v-list-item-avatar>
                                                    </div>
                                                </div>
                                                <div v-else>{{index+1}}</div>
                                                
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                {{item.name}}({{item.number}})
                                            </v-list-item-content>
                                            
                                            <v-list-item-action/>  
                                            <v-list-item-action>
                                                {{item.totalVotes}}
                                            </v-list-item-action>
                                        </template>
                                        <template>
                                            <v-layout class="not-fullwidth">
                                                <not-table-results class="not-fullwidth"
                                                @onDeleteResult="deleteResult"
                                                @onEditResult="editResult"
                                                :not="not"
                                                :notTitle="item.name"
                                                :notShow="true"
                                                :notItems="filterResults(item)"
                                                :notHeaders="headerss('results_customise')"/>
                                            </v-layout>
                                        </template> 
                                    </v-list-group>
                                    
                                </div> 
                            </div>
                            <div v-else class="pa-4 b2 text-center">
                                <v-icon>warning</v-icon>
                                <div v-if="searchGroup===''" class="">
                                    Empty
                                </div>
                                <div v-else>
                                    No matching records found.
                                </div>
                            </div>

                        </v-list> 

                        <!-- FOOTER -->
                        <v-list-item class="primary lighten-3" >
                            <v-list-item-action>
                                <div class="not-f2"></div>
                            </v-list-item-action>
                            <v-list-item-content>
                                <div class="not-f5">TOTAL VOTES</div>
                            </v-list-item-content> 
                            <v-list-item-action><div class="not-f5">{{listGroupResults(isGrouped()).TOTAL}}</div></v-list-item-action>
                            <v-list-item-action/>   
                            <v-list-item-action/>
                        </v-list-item  >
                    </div>  

                </div>
            </v-card> 
            <div v-else>
                <v-layout  justify-center="" align-center="" class=" primary lighten-4  pa-5 ">
                    <v-icon size="50" color="primary">mdi-shield-account</v-icon>
                    <div>You do not have permission to read results.</div> 
                </v-layout> 
            </div>
        </div> 
    </v-layout>

    <!-- add -->
    <v-dialog v-model="dialog_add_result" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">ADD RESULTS</span>
                <v-spacer></v-spacer>
                <v-btn @click="addExcelResuts()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn>

                <v-btn class="ml-2" color="white" icon @click="dialog_add_result=false"><v-icon>close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submited()" autocomplete="false">
                        <v-layout row wrap class="pa-1">  
                            <!-- type -->
                            <v-flex xs12  sm6 > 
                                <v-autocomplete  autocomplete="off"
                                    v-model="input_submitLevel"
                                    :items="submitLevel" 
                                    @change="input={}"
                                    filled   
                                    label="Submitting level"/>
                            </v-flex>   
                            
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.region_code" 
                                    filled 
                                    :append-icon="!activateField('region')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('region')"
                                    :items="not.selectorNames(regions)"
                                    label="Select Region"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.district_code" 
                                    filled
                                    :append-icon="!activateField('district')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('district')"
                                    :items="not.selectorNames(FT_districts)"
                                    label="Select District"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.constituency_code" 
                                    filled
                                    :append-icon="!activateField('constituency')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('constituency')"
                                    :items="not.selectorNames(FT_constituencies)"
                                    label="Select Constituency"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.ward_code" 
                                    filled
                                    :append-icon="!activateField('ward')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('ward')"
                                    :items="not.selectorNames(FT_wards)"
                                    label="Select Wards"/>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-autocomplete autocomplete="off"
                                    v-model="input.centre_code" 
                                    filled
                                    :append-icon="!activateField('centre')?'error':'mdi-menu-down'"
                                    :disabled="!activateField('centre')"
                                    :items="not.selectorNames(FT_centres)"
                                    label="Select Centres"/>
                            </v-flex> 

                            <v-flex xs12>
                                <v-text-field  required
                                filled=""  
                                type="text"
                                v-model="input.form_numbe" 
                                label="Form Number" > 
                                </v-text-field >
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="input_nullAndVoid" 
                                label="NULL AND VOID" > 
                                </v-text-field >
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="input_validVotes" 
                                label="TOTAL VALID VOTES" > 
                                </v-text-field >
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="input_total_cast" 
                                label="TOTAL VOTE CAST" > 
                                </v-text-field >
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="input_total_registered" 
                                label="TOTAL VALID VOTES" > 
                                </v-text-field >
                            </v-flex> 

                            <v-layout justify-center="" >
                                 <v-subheader class="primary--text">CANDIDATES</v-subheader>
                            </v-layout>
                             
                            <v-flex xs12 v-for="(candidate, index) in candidates" :key="index" >
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="form['candidate_code:'+candidate.code]" 
                                :label="candidate.name" > 
                                </v-text-field >
                            </v-flex>  

                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_add_result=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">Submit</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click Excel button to ADD results using Excel template.</small>
            </v-card-text> 
      </v-card>
    </v-dialog>

    <!-- edit -->
    <v-dialog v-model="dialog_edit_result" persistent max-width="800px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">EDIT RESULTS</span>
                <v-spacer></v-spacer> 
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submitedEdit()">
                        <v-layout row wrap class="pa-1">   
                             <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.candidate_code" 
                                    filled
                                    :items="not.selectorNames(candidates)"
                                    label="Candidate"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.region_code" 
                                    filled
                                    :items="not.selectorNames(regions)"
                                    label="Select Region"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.district_code" 
                                    filled
                                    :items="not.selectorNames(districts)"
                                    label="Select District"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.constituency_code" 
                                    filled
                                    :items="not.selectorNames(constituencies)"
                                    label="Select Constituency"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.ward_code" 
                                    filled
                                    :items="not.selectorNames(wards)"
                                    label="Select Wards"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12 sm6>
                               <v-select
                                    v-model="input.centre_code" 
                                    filled
                                    :items="not.selectorNames(centres)"
                                    label="Select Centre"
                                    ></v-select>
                            </v-flex> 
                            <v-flex xs12>
                                <v-text-field  required
                                filled=""  
                                type="number"
                                v-model="input.votes" 
                                label="VOTES" > 
                                </v-text-field >
                            </v-flex> 
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_edit_result=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">Save</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click Excel button to ADD results using Excel template.</small>
            </v-card-text> 
      </v-card>
    </v-dialog>

    <!-- select -->
    <div v-if="excelSelecter">
        <not-selecter-excel 
            :notShow="excelSelecter"
            @notNo="excelSelecter =!excelSelecter"
            @notYes="fileSelected"/>
    </div>

    <!-- Selected -->
    <v-dialog v-model="dialog_selected_results" persistent max-width="1200px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">UPLOAD RESULTS</span>
                <v-spacer></v-spacer>
                <v-btn  @click="dialog_selected_results=false" color="white" icon="" class="ml-2"><v-icon size="" class="pr-1">mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text> 

                <br><br>
                <v-flex xs12 > 
                    <v-autocomplete  autocomplete="off"
                        v-model="input_submitLevel"
                        :items="submitLevel" 
                        @change="input={}"
                        filled   
                        label="Submitting level"/>
                </v-flex> 
                <v-container grid-list-lg v-if="input_submitLevel">
                    <br> 
                    <div v-if="JOINED_XL_results">
                        <div>
                            <v-alert
                                outlined
                                type="error"
                                prominent
                                border="left">
                                You have {{JOINED_XL_results.errors.length}} Errors. <br><br>
                                <div v-for="(error, index) in JOINED_XL_results.errors" :key="index">
                                    ({{error.no}}) {{error.name}}
                                </div>
                            </v-alert>
                        </div>
                        <v-data-table
                            :headers="headerss('excel')"
                            :items="JOINED_XL_results.results"
                            :search="search" >

                            <template v-slot:top>
                                
                            </template> 

                            <template v-slot:item.error="{ item }"> 
                                <div v-if="item.error==true" class="error--text">
                                    <v-icon color="error">error</v-icon> ERROR 
                                </div>
                                <div v-else class="green--text">
                                    OK
                                </div>
                            </template> 

                            <template v-slot:item.action="{ item }" > 
                                
                                <v-hover v-slot:default="{hover}" class="ma-1">
                                    <v-avatar tile color="primary" class="pa-1">
                                        <v-icon size="18" dark @click="editXlResult(item)" :class="hover?'white':''" :color="hover?'primary':'white'">mdi-pencil</v-icon>
                                    </v-avatar>
                                </v-hover> 
                                <v-hover v-slot:default="{hover}" class="ma-1">
                                    <v-avatar tile color="red" class="pa-1" >
                                        <v-icon size="18" dark @click="deleteXlResult(item)" :class="hover?'white':''" :color="hover?'red':'white'">mdi-close</v-icon>
                                    </v-avatar>
                                </v-hover> 
                            </template>
                            <template v-slot:no-data>
                                <v-layout align-center="" justify-center="" class="primary lighten-5 pa-5">
                                    <v-icon>warning</v-icon>
                                    Empty
                                </v-layout>
                            </template>
                        </v-data-table>    
                    </div>
                    
                </v-container>
                <v-divider></v-divider>
                <br>
                <v-layout justify-center=""> 
                    <!-- <v-btn :loading="input.loading" @click="uploadXl()" color="primary lighten-3" class="mr-2" ><v-icon class="mr-2">mdi-cloud-sync</v-icon> UPLOAD TO OLD LIST</v-btn> -->
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog_selected_results=false" color="primary" text="">CANCEL</v-btn>
                    <v-btn :loading="input.loading" @click="uploadXlNew()" color="primary "><v-icon class="mr-2">mdi-cloud-upload</v-icon> UPLOAD RESULTS</v-btn>
                </v-layout>
            </v-card-text> 
      </v-card>
    </v-dialog>

</v-layout>
</template>

<script> 
    
    let pageName = 'ManageResults'
    let district = []
    district["district"]=false
    district["constituency"]=false
    district["ward"]=false
    district["centre"]=true
    let ACTION_TIME = 100
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            page_show_results: false, 
             
            dialog_add_result:false,
            dialog_edit_result:false,
            dialog_selected_results:false,
            menuFilter:false,
            menuGroup:false,
            excelSelecter:false,
            EXCEL_JS_results:[],
            input_submitLevel:'constituency',
            input:{}, 
            input_nullAndVoid:null,
            input_validVotes:null,
            input_total_cast:null,
            input_total_registered:null,
            form: { 
            },
            search: '',
            searchGroup:'',
            xHeader_results_customise:[ 
                {id:1,name:"General",title:true},
                {id:0,name:"Number",show:true},
                {id:0,name:"Level",show:true},
                {id:3,name:"Votes",show:true},
                {id:26,name:"ACTION",show:false},

                {id:1,name:"Submitted",title:true},
                {id:4,name:"Submitted Date",show:false}, 
                {id:4,name:"Observer Name",show:false},
                {id:5,name:"Observer Email",show:false},
                {id:6,name:"Observer Phone",show:false},
                {id:7,name:"Observer Type",show:false},

                {id:1,name:"Candidate",title:true},
                {id:2,name:"Candidate Name",show: true},
                {id:2,name:"Candidate Code",show: false},
                {id:2,name:"Candidate Gender",show: false},
                {id:2,name:"Candidate Age",show: false},

                {id:8,name:"Party",title:true},
                {id:9,name:"Party Name",show:false},
                {id:10,name:"Party Short Name",show:true},
                {id:11,name:"Party Code",show:false},

                {id:12,name:"Region",title:true},
                {id:13,name:"Region Name",show:false},
                {id:14,name:"Region Code",show:false},

                {id:15,name:"District",title:true},
                {id:16,name:"District Name",show:true},
                {id:17,name:"District Code",show:false},

                {id:18,name:"Constistuency",title:true},
                {id:19,name:"Constituency Name",show:false},
                {id:20,name:"Constituency Code",show:false},

                {id:21,name:"Ward",title:true},
                {id:22,name:"Ward Name",show:false},
                {id:23,name:"Ward Code",show:false},

                {id:24,name:"Centre",title:true},
                {id:25,name:"Centre Name",show:true},
                {id:26,name:"Centre Code",show:false}
                
            ],
            xHeader_results_group:[ 
                {id:0,name:"Show All",show:false},
                {id:1,name:"Goup as:",title:true},
                {id:2,name:"Candidates",show:true},
                {id:3,name:"Regions",show:false},
                {id:4,name:"Districts",show:false},
                // {id:5,name:"Constituencies",show:false}, 
                // {id:6,name:"Wards",show:false}, 
            ],
            xHeader_results_district:[  
                {id:0,name:"Number",show:true}, 
                //{id:26,name:"ACTION",show:true}, 
                {id:1,name:"Error",show:true}, 
                {id:16,name:"District Name",show:true},
                {id:17,name:"District Code",show:true}, 
                {id:17,name:"Candidates Results Code",show:true}, 
            ],
            xHeader_results_constituency:[  
                {id:0,name:"Number",show:true}, 
                //{id:26,name:"ACTION",show:true}, 
                {id:1,name:"Error",show:true}, 
 
                {id:16,name:"Constituency Name",show:true},
                {id:17,name:"Constituency Code",show:true}, 
                {id:17,name:"Candidates Results Code",show:true}, 
            ],
            xHeader_results_ward:[  
                {id:0,name:"Number",show:true}, 
                //{id:26,name:"ACTION",show:true}, 
                {id:1,name:"Error",show:true}, 
 
                {id:16,name:"Ward Name",show:true},
                {id:17,name:"Ward Code",show:true}, 
                {id:17,name:"Candidates Results Code",show:true}, 
            ],
            xHeader_results_centre:[  
                {id:0,name:"Number",show:true}, 
                //{id:26,name:"ACTION",show:true},   
                {id:1,name:"Error",show:true},

                {id:16,name:"centre Name",show:true},
                {id:17,name:"centre Code",show:true}, 
                {id:17,name:"Candidates Results Code",show:true}, 
                
            ],
             
        }),  
        created(){
             this.EventBus.$on('notYesDialog', this.notYesDialog); 
        },
        mounted() {   
            this.pageLoad(1000) 

        },
        computed:{ 
            accessResults(){
                return permission=>{
                    if (permission === "read") {
                        return this.not.ACCESS_READ("results") 
                    }else if (permission === "write") {
                        return this.not.ACCESS_WRITE("results") 
                    }else if (permission === "edit") {
                        return this.not.ACCESS_EDIT("results") 
                    }else if (permission === "delete") {
                        return this.not.ACCESS_DELETE("results") 
                    }else{
                        return false
                    }
                }
            },
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            ud(){
                return this.not.ud
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            }, 
            resultsType(){
                let sw = this.submitResultsLevel 
                let type = ""
                if (this.not.TEXT_EQ(sw,'Districts')) {
                    type = 'district'
                }else if (this.not.TEXT_EQ(sw,'Constituencies')) {
                    type = 'constituency'
                }else if (this.not.TEXT_EQ(sw,'Wards')) {
                    type = 'ward'
                }else if (this.not.TEXT_EQ(sw,'Centres')) {
                    type = 'centre'
                } 
                return type
            },
            results(){
                return type=>{
                    return this.$store.getters.getResults(type)
                }
            },
            resultsDetails(){
                return type=>{
                    return this.$store.getters.getResultsDetails(type)
                }
            },
            submitLevel(){
                return this.$store.getters.getSubmitLevel
            },
            submitResultsLevel(){
                return this.$store.getters.getSubmitResultsLevel
            },
            regions(){
                return this.$store.getters.getRegions
            }, 
            districts(){
                return this.$store.getters.getDistricts
            }, 
            constituencies(){
                return this.$store.getters.getConstituencies
            }, 
            wards(){
                return this.$store.getters.getWards
            }, 
            centres(){
                return this.$store.getters.getCentres
            }, 
            FT_districts(){
                let districts = this.districts
                let input_ = this.input.region_code
                if (!districts) {return null}
                if (!input_) {return null}
                let region_code = this.not.selectorNamesCode(this.regions,input_) 
                let fts = districts.filter(ds=>{
                    return ds.region_code == region_code
                })
                return fts
            }, 
            FT_constituencies(){
                let constituencies = this.constituencies
                let input_ = this.input.district_code
                if (!constituencies) {return null}
                if (!input_) {return null}
                let district_code = this.not.selectorNamesCode(this.districts,input_ ) 
                let fts = constituencies.filter(item=>{
                    return item.district_code == district_code
                })
                return fts
            }, 
            FT_wards(){
                let wards = this.wards
                let input_ = this.input.constituency_code
                if (!wards) {return null}
                if (!input_) {return null}
                let constituency_code = this.not.selectorNamesCode(this.constituencies,input_) 
                let fts  = wards.filter(item=>{
                    return item.constituency_code == constituency_code
                })
                return fts
            },
            FT_centres(){
                let centres = this.centres
                let input_ = this.input.constituency_code
                if (!centres) {return null}
                if (!input_) {return null}
                let ward_code = this.not.selectorNamesCode(this.wards,input_) 
                let fts  = centres.filter(item=>{
                    return item.ward_code == ward_code
                })
                return fts
            },
            
            candidates(){
                return this.$store.getters.getCandidates
            },
            JOINED_results(){
                let resultsType = this.resultsType
                let results = this.results(resultsType) 
                let resultsDetails = this.resultsDetails(resultsType)  
                let joinedResults = this.not.JOIN_RESULTS(results,resultsDetails)
                return joinedResults
            },
            JOINED_XL_results(){
                
                let results = this.EXCEL_JS_results
                let type = this.input_submitLevel
                let joinedXLResults = this.not.JOIN_XL_RESULTS(results,type)
                return joinedXLResults
            }
            
        },
        //------------methods---------------
        methods: { 
            clicked(data){ 
                
            },
            changeResultsType(type){ 
                if (this.not.TEXT_EQ(type,this.submitResultsLevel)) {
                    this.input.check = true
                    this.not.notDialog(true,true,"RESULTS LEVEL",this.not.TEXT_UP(type+" Level")+' is now selected.','',"OK")
                } else {
                    this.input.check = true
                    this.not.notDialog(true,true,"CHANGE RESULTS LEVEL",'Are you sure you want to change results level to '+this.not.TEXT_UP(type+" level?"),'CANCEL',"CHANGE",{
                        code:pageName+"=ADD-SUBMITTED-RESULTS-LEVEL",
                        data:type, 
                    }) 
                }
                
            },
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+'=ADD-SUBMITTED-RESULTS-LEVEL') {
                        if (this.input.check) { 
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_set",{ 
                                    data:action.data,
                                    path:"/RESULTS/Level/",
                                    action:"results",
                                    us:this.us,
                                    array:"true"
                                }) 
                            }, ACTION_TIME);  
                        } 
                    } 

                    if (action.code ===pageName+'=ADD-RESULT') {
                        if (this.input.check) { 
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_add_results",{ 
                                    details:action.details,
                                    results:action.results,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);  
                        } 
                    }  
                    if (action.code ===pageName+'=EDIT-RESULT') {
                        if (this.input.check) {  
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_update",{
                                    action:"result",
                                    path:"/Results/"+action.details.key+"/",
                                    data:action.details,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);   
                        } 
                    } 
                    if (action.code ===pageName+'=ADD-RESULTS-SUCCESS') {
                        this.dialog_add_result = false
                        this.dialog_selected_results = false
                    }
                    if (action.code ===pageName+'=EDIT-RESULTS-SUCCESS') {
                        this.dialog_edit_result = false
                    }

                    if (action.code ===pageName+'=CONFIRM-DELETE-RESULT') {
                        if (this.input.check) {  
                            setTimeout(() => { 
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting this result.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-RESULT",
                                }) 
                            }, ACTION_TIME);
                        }  
                    } 
                    if (action.code ===pageName+"=CONFIRM-DELETE-ALL-RESULTS") {
                        if (this.input.check) {  
                            setTimeout(() => {
                                this.not.notDialogCp(true,true,"CONFIRM","Enter your password to confirm deleting ALL results. This action can not be reversed.","CANCEL","CONFIRM",{
                                    ...action,
                                    code:pageName+"=DELETE-ALL-RESULTS",
                                })  
                            }, ACTION_TIME);
                        }   
                    }  
                    if (action.code ===pageName+'=DELETE-RESULT') {
                        if (this.input.check) {  
                            this.input.check = false 
                            let level = action.result.level
                            level = level.charAt(0).toUpperCase() + level.substring(1);
                            let path="/RESULTS/"+level+"/Results/"+action.result.key+"/" 
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {   
                                    this.$store.dispatch("fi_delete",{
                                        action:"result",
                                        path:path
                                    }) 
                                } 
                            }, ACTION_TIME);   
                        }  
                    } 
                    if (action.code ===pageName+'=DELETE-ALL-RESULTS') {
                        if (this.input.check) {  
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.check = false
                                let password = action.password
                                if (password!==this.ud.password) {
                                    this.not.notDialog(true,false,"ERROR","Wrong password entered.","OK")
                                } else {   
                                    this.$store.dispatch("fi_delete",{
                                        action:"result",
                                        path:"/RESULTS/"+action.level+"/" 
                                    }) 
                                } 
                            }, ACTION_TIME);   
                        }    
                    } 
                    if (action.code ===pageName+'=SELECT-EXCEL') {
                        this.addExcelResuts()  
                    } 
                    if (action.code ===pageName+'=REMOVE-XL-RESULT') {
                        let result =action.result 
                        let districts = this.EXCEL_JS_results
                        this.EXCEL_JS_results = districts.filter(ds=>{
                            return ds.code != district.code
                        }) 
                    } 

                    if (action.code ===pageName+'=XL-UPLOAD-NEW') {
                        if (this.input.check) { 
                            this.input.check = false 
                            setTimeout(() => {
                                this.input.loading = true 
                                this.$store.dispatch("fi_add_xl_results",{  
                                    xl_results:action.xl_results.results,
                                    level:action.xl_results.level,
                                    us:this.us
                                }) 
                            }, ACTION_TIME);  
                        }  
                    } 
                }
            },
            activateField(field){
                let submitLevel = this.input_submitLevel
                let region_code = this.input.region_code
                let district_code = this.input.district_code
                let constituency_code = this.input.constituency_code
                let ward_code = this.input.ward_code
                if (!field) {
                    return false
                }
                if (!submitLevel) {
                    return false
                }

                //check selected
                if (!region_code) {
                    if (field==='district') {
                        return false
                    }
                    if (field==='constituency') {
                        return false
                    }
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!district_code) { 
                    if (field==='constituency') {
                        return false
                    }
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!constituency_code) {  
                    if (field==='ward') {
                        return false
                    }
                    if (field==='centre') {
                        return false
                    }
                }
                if (!ward_code) {  
                    if (field==='centre') {
                        return false
                    }
                }

                //check level
                if (submitLevel==='centre') {
                    return true
                }else if (submitLevel==='ward') {
                    if (field==='region') {
                        return true
                    }
                    if (field==='district') {
                        return true
                    }
                    if (field==='constituency') {
                        return true
                    }
                    if (field==='ward') {
                        return true
                    }
                }else if (submitLevel==='constituency') {
                    if (field==='region') {
                        return true
                    }
                    if (field==='district') {
                        return true
                    }
                    if (field==='constituency') {
                        return true
                    }
                }else if (submitLevel==='district') {
                    if (field==='region') {
                        return true
                    }
                    if (field==='district') {
                        return true
                    }
                }  
                return false
            },
            addResult(){
                let p = this.accessResults("write")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you do not have permission to write results. Contact system admin for more info.","OK") 
                } else {
                    this.input = {}
                    this.dialog_add_result = true
                }
            },
            candidateResults(){
                let form = this.form
                let candidates = this.candidates
                if (!form) {return null}
                if (!candidates) {return null}

                let results=[]
                candidates.forEach(item => {
                    let code = item.code
                    let votesValue = form["candidate_code:"+code]

                    let result= {
                        candidate_code:code,
                        votes:votesValue,
                        level:this.input_submitLevel
                    }
                    results.push(result)
                })
                results.push({
                    candidate_code:"NULL&VOID",
                    votes:this.input_nullAndVoid,
                    level:this.input_submitLevel
                })
                results.push({
                    candidate_code:"VALID-VOTES",
                    votes:this.input_validVotes,
                    level:this.input_submitLevel
                })
                return results
            },
            submited(){  
                if (this.input_submitLevel) {
                    this.input.region_code = this.not.selectorNamesCode(this.regions,this.input.region_code) 
                    let tracking_key = this.input.region_code
                    if (this.input_submitLevel==="district") {
                        if (!this.input.district_code) {
                            this.not.notDialog(true,true,"DISTRICT ERROR","Make sure you select a district and try again.","OK")
                            return 
                        }
                        this.input.district_code = this.not.selectorNamesCode(this.districts,this.input.district_code)
                        tracking_key = tracking_key+";"+this.input.district_code 
                    }else if (this.input_submitLevel==="constituency") {
                        if (!this.input.constituency_code) {
                            this.not.notDialog(true,true,"CONSTITUENCY ERROR","Make sure you select a constituency and try again.","OK")
                            return 
                        }
                        this.input.district_code = this.not.selectorNamesCode(this.districts,this.input.district_code)
                        this.input.constituency_code = this.not.selectorNamesCode(this.constituencies,this.input.constituency_code)
                        tracking_key = tracking_key+";"+this.input.district_code+";"+this.input.constituency_code
                    }else if (this.input_submitLevel==="ward") {
                        if (!this.input.ward_code) {
                            this.not.notDialog(true,true,"WARD ERROR","Make sure you select a ward and try again.","OK")
                            return 
                        }
                        this.input.district_code = this.not.selectorNamesCode(this.districts,this.input.district_code)
                        this.input.constituency_code = this.not.selectorNamesCode(this.constituencies,this.input.constituency_code)
                        this.input.ward_code = this.not.selectorNamesCode(this.wards,this.input.ward_code)
                        tracking_key = tracking_key+";"+this.input.district_code+
                        ";"+this.input.constituency_code+";"+this.input.ward_code
                    }else if (this.input_submitLevel==="centre") {
                        if (!this.input.centre_code) {
                            this.not.notDialog(true,true,"CENTRE ERROR","Make sure you select a centre and try again.","OK")
                            return 
                        }
                        this.input.district_code = this.not.selectorNamesCode(this.districts,this.input.district_code)
                        this.input.constituency_code = this.not.selectorNamesCode(this.constituencies,this.input.constituency_code)
                        this.input.ward_code = this.not.selectorNamesCode(this.wards,this.input.ward_code)
                        this.input.centre_code = this.not.selectorNamesCode(this.centres,this.input.centre_code)
                        tracking_key = tracking_key+";"+this.input.district_code+
                        ";"+this.input.constituency_code+";"+this.input.ward_code+";"+this.input.centre_code
                    }

                    let detail = {
                        ...this.input,
                        tracking_key:tracking_key,
                        user_type:"admin",
                        uid:this.us.uid,
                        level:this.input_submitLevel

                    } 
                    this.input.check = true
                    this.not.notDialog(true,true,"ADD RESULT",'Are you sure you want to add this result?','CANCEL',"ADD",{
                        code:pageName+"=ADD-RESULT",
                        details:detail,
                        results:this.candidateResults()
                    }) 
                }else{
                    this.not.notDialog(true,true,"REGION ERROR","Make sure you select a region and try again.","OK")
                }
            },
            
            editResult(result){ 
                let p = this.accessResults("write")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you do not have permission to edit results. Contact system admin for more info.","OK") 
                } else {
                    this.input = {}
                    this.input.votes = result.votes
                    this.input.code = result.code
                    this.input.candidate_code = this.not.selectorCodeName(this.candidates, result.candidate_code)
                    this.input.region_code = this.not.selectorCodeName(this.regions, result.region_code)
                    this.input.district_code = this.not.selectorCodeName(this.districts, result.district_code)
                    this.input.constituency_code = this.not.selectorCodeName(this.constituencies, result.constituency_code)
                    this.input.ward_code = this.not.selectorCodeName(this.wards, result.ward_code)
                    this.input.centre_code = this.not.selectorCodeName(this.centres, result.centre_code) 
                    

                    this.input.key = result.key 
                    this.dialog_edit_result = true
                } 
            }, 
            submitedEdit(){
                this.input.region_code = this.not.selectorNamesCode(this.regions,this.input.region_code) 
                this.input.check = true
                this.not.notDialog(true,true,"EDIT RESULT",'Are you sure you want to edit this result?','CANCEL',"EDIT",{
                    code:pageName+"=EDIT-RESULT",
                    details:this.input
                }) 
            },
            deleteResult(result){ 
                let p = this.accessResults("delete")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you do not have permission to delete results. Contact system admin for more info.","OK") 
                } else {
                    this.input.check = true
                    this.not.notDialog(true,true,"DELETE RESULT",'Are you sure you want to delete this result?','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-RESULT",
                        result:result
                    })  
                    
                } 
            },
            deleteAllResults(){
                let p = this.accessResults("delete")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you do not have permissio to delete results. Contact system admin for more info.","OK") 
                } else {
                    let level = this.resultsType
                    level = level.charAt(0).toUpperCase() + level.substring(1);
                    this.input.check = true
                    this.not.notDialog(true,true,"DELETE "+level.toUpperCase()+" RESULTS",'Are you sure you want to delete all the '+level+' results from the database?','CANCEL',"DELETE",{
                        code:pageName+"=CONFIRM-DELETE-ALL-RESULTS",
                        level:level
                    })   
                } 
            },

            listGroupResults(type){
                let resultsType = this.resultsType
                let search = this.searchGroup
                let results = this.results(resultsType)
                let items = this.not.GROUP_RESULTS(results,type,resultsType) 
                if (!items) {
                    return []
                }
                if (search) {
                    items.items = items.items.filter(it=>{
                        let index = it.name.toUpperCase().includes(search.toUpperCase())
                        return index 
                    }) 
                }   
                return items 
            },
            groupResults(item,i){
                let xHeader_results_group = this.xHeader_results_group
                if (!item) { return}
                if (!xHeader_results_group) {return}
                xHeader_results_group.forEach(it => {
                    it.show = false
                });
                xHeader_results_group[i].show = !item.show
            },
            isGrouped(name){
                let xHeader_results_group = this.xHeader_results_group 
                if (!xHeader_results_group) {return null}

                let returne = null
                if (name) {
                    xHeader_results_group.forEach(it => {
                       if (it.name==name) {
                           returne = it.show
                       }
                    });  
                }else{
                    xHeader_results_group.forEach(it => {
                       if (it.show) {
                           returne = it.name
                       }
                    }); 
                }
                return returne
            },
            filterResults(item){ 
                if(!item){return []}
                let code = item.code
                let results = this.JOINED_results
                if(!code){return []}
                if(!results){return []}
                 let candResults = null
                if (this.isGrouped()==="Candidates") {
                    candResults = results.filter(it=>{
                        return it.candidate_code == code
                    }) 
                } else if (this.isGrouped()==="Regions") {
                    candResults = results.filter(it=>{
                        return it.region_code == code
                    }) 
                } else if (this.isGrouped()==="Districts") {
                    candResults = results.filter(it=>{
                        return it.district_code == code
                    }) 
                } 

                return candResults
            },  
            
            //Heades
            headerss(type){
                let hds = null
                if (type === 'results_customise') {
                    hds = this.xHeader_results_customise
                }else if (type === 'results_group'){
                    hds = this.xHeader_results_group
                }else if (type === 'excel'){
                    if (this.input_submitLevel==='district') {
                      hds = this.xHeader_results_district  
                    }else if (this.input_submitLevel==='constituency') {
                      hds = this.xHeader_results_constituency 
                    }else if (this.input_submitLevel==='ward') {
                      hds = this.xHeader_results_ward 
                    }else if (this.input_submitLevel==='centre') {
                      hds = this.xHeader_results_centre
                    }else {
                      hds = this.xHeader_results_constituency 
                    } 
                } 
                let headers = this.not.TABLE_HEADERS(hds) 
                return headers
            },

            //xl
            editXlResult(result){
                this.not.notDialog(true,false,null,"This option is currently unavailable. Please edit from the file.","OK")
            },
            deleteXlResult(result){
                this.not.notDialog(true,true,"REMOVE RESULT","Are you sure, you want to remove this result from the list?","CANCEL","REMOVE",{
                    code:pageName+"=REMOVE-XL-RESULT",
                    result:result
                }) 
            },
            uploadXl(){
                this.not.notDialog(true,true,"UPLOAD TO LIST","Upload to already existing list.","CANCEL","UPLOAD",{
                    code:pageName+"=XL-UPLOAD-OLD",
                    districtS:this.EXCEL_JS_results
                }) 
            },
            uploadXlNew(){
                this.input.check = true
                let error_number = this.JOINED_XL_results.errors.length 
                
                if (error_number>0) {
                    this.not.notDialog(true,true,"EXCLUDE ERRORS & UPLOAD","The selected Excel file contains errors. If you choose to upload, the row with error will be excluded.","CANCEL","UPLOAD",{
                        code:pageName+"=XL-UPLOAD-NEW",
                        xl_results:this.removeErrors(this.JOINED_XL_results)
                    })  
                }else{ 
                    this.not.notDialog(true,true,"UPLOAD RESULTS","Are you sure you want to upload results from the selected Excel file?","CANCEL","UPLOAD",{
                        code:pageName+"=XL-UPLOAD-NEW",
                        xl_results:this.JOINED_XL_results
                    })  
                } 
                
            },
            removeErrors(results){
                let newResuts = results.results.filter(re=>{
                    return re.error == false
                })
                return {
                    ...results,
                    results:newResuts
                }
            },

            downloadResults(){
                this.not.notDialog(true,true,"ERROR","Download for results is currently not working.", "OK" ) 
            },
            findTotalRegistered(value){
                if(!value){return}
                let level = this.submitLevel
                let code = 0
                let item = null 
                if (level.indexOf("centre")!==-1) {
                    code = this.not.selectorNamesCode(this.centres,value.centre?value.centre.centre_code:null) 
                    item = this.$store.getters.getCentreByCode(code)
                }else if (level.indexOf("ward")!==-1) {
                    code = this.not.selectorNamesCode(this.wards,value.ward?value.ward.ward_code:null) 
                    item = this.$store.getters.getWardByCode(code)
                }else if (level.indexOf("constituency")!==-1) {
                    code = this.not.selectorNamesCode(this.constituencies,value.constituency?value.constituency.constituency_code:null) 
                    item = this.$store.getters.getConstituencyByCode(code)
                }else if (level.indexOf("district")!==-1) {
                    code = this.not.selectorNamesCode(this.districts,value.district?value.district.district_code:null) 
                    item = this.$store.getters.getDistrictByCode(code)
                }

                let totalRegistered = item?item.total_registered:null
                if (totalRegistered) {
                    this.input_total_registered = totalRegistered
                }
                console.log(level,code,item,totalRegistered);
                
            },
            
            //-----------------[SELECT FILE]-----------
            addExcelResuts(){  
                let p = this.accessResults("write")
                if (!p) {
                   this.not.notDialog(true,false,"PERMISSION DENIED","Sorry, you do not have permission to write results. Contact system admin for more info.","OK") 
                } else {
                    this.dialog_add_result = false
                    this.excelSelecter = !this.excelSelecter
                }
            }, 
            fileSelected(wb){
                this.WB = wb
                this.excelSelecter = false
                this.EXCEL_JS_results=[] 

                let ws_results = wb.Sheets["results"]  
                if (!ws_results) {
                    this.not.notDialog(true,true,"ERROR","The selected file does not contain result work sheet. Please, make sure you selected the right file and try again.","CANCEL","TRY AGAIN",{
                        code:pageName+"=SELECT-EXCEL"
                    })
                } else { 
                    let results = this.XLSX.utils.sheet_to_json(ws_results)  
                    let jn_results = []
                    results.forEach(ds => {
                        let dt = new Date
                        let date = dt.toISOString()

                        jn_results.push({
                            ...ds,
                            date:date,
                            uid:this.us.uid
                        })
                    }); 
                    this.EXCEL_JS_results = jn_results 
                    this.dialog_selected_results = true
                }
            },

            //-----------------[PAGE CONTRAL]---------
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let get_results_district = ps.find(process=>{
                            return process.name == 'getting/results/district'
                        })
                        let get_results_constituency = ps.find(process=>{
                            return process.name == 'getting/results/constituency'
                        })
                        let get_results_ward = ps.find(process=>{
                            return process.name == 'getting/results/ward'
                        })
                        let get_results_centre = ps.find(process=>{
                            return process.name == 'getting/results/centre'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/results'
                        })  
                        let updating = ps.find(process=>{
                            return process.name == 'updating/results'
                        })  
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/result'
                        }) 
                        let setting = ps.find(process=>{
                            return process.name == 'setting/results'
                        }) 

                        if (logging) {
                            this.page_show =false
                            this.not.notDialogP(true,true,'Logging...')
                        }else{ 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        let getting = null
                        if (this.resultsType==="district") {
                            getting = get_results_district
                        }else if (this.resultsType==="constituency") {
                            getting = get_results_constituency
                        }else if (this.resultsType==="ward") {
                            getting = get_results_ward
                        }else if (this.resultsType==="centre") {
                            getting = get_results_centre
                        } 
                        
                        if (getting) {
                            this.page_show_results =false
                            this.not.notDialogP(true,false,'Loading...')
                        }else{ 
                            this.page_show_results =true
                        }

                        
                        if (adding) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        } 
                        if (updating) {
                            this.not.notDialogP(true,false,'Saving...')
                            this.input.loading = true
                        }else{ 
                        }   
                        if (deleting) {
                            this.not.notDialogP(true,false,'Deleting...') 
                        }else{ 
                        }  

                        if (setting) {
                            this.not.notDialogP(true,false,'Uploading...')
                            this.input.loading = true
                        }else{ 
                        } 

                        //IF ALL DONE
                        if (ps.length===0) { 
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                            this.not.notDialogP(false)
                        }
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        this.not.notDialogP(false)
                    }

                    //check response
                    if (res.res==='adding/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Result successfully added.','','OK',{code:pageName+'=ADD-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='adding/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding the result. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=ADD-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 


                     if (res.res==='updating/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Result successfully edited.','','OK',{code:pageName+'=EDIT-RESULTS-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while editing the result. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=EDIT-RESULTS-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                     
                    if (res.res==='deleting/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Result successfully deleted.','','OK',{code:pageName+'=DELETE-RESULTS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='deleting/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting result. Make sure your password is correct or contact admin.','','OK',{code:pageName+'=DELETE-RESULTS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 

                    if (res.res==='setting/results/successful') { 
                        this.not.notDialog(true,true,'Successful','Results successfully upload.','','OK',{code:pageName+'=SETTING-RESULTS-SUCCESS'}) 
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                        this.dialog_selected_results = false
                    }else if (res.res==='setting/results/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while uploading results. ','','OK',{code:pageName+'=SETTING-RESULTS-ERROR'}) 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                        this.dialog_selected_results = false
                    } 
 
                },t)
            }
        }, 
        watch: {
            us(v){
                
            }, 
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            },
            input(value){
               this.findTotalRegistered(value)
            }
             
        },
    } 
    
</script>
 
